import React from 'react';
import { Box, Typography } from '@mui/material';

function AffidavitListHeader({ title }) {
  return (
    <Box className="affidavit-list-header">
      <Typography className="affidavit-list-header-title">{title}</Typography>
    </Box>
  );
}

export default AffidavitListHeader; 